import {Component, HostBinding, Input} from '@angular/core';
import { Platform } from '../../models/chat-library.models';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';

const PLATFORM_ICON_MAP: Record<string, string> = {
  facebook: 'svg/Facebook.svg',
  instagram: 'svg/Instagram.svg',
  messenger: 'svg/Messenger.svg',
  threads: 'svg/Threads.svg',
  meta: 'svg/Meta.svg',
  linkedin: 'svg/LinkedIn.svg',
};

const GLOBE_ICON = 'svg/globe.svg';

@Component({
  selector: 'app-platform-icons',
  standalone: true,
  imports: [AssetVersionPipe],
  templateUrl: './platform-icons.component.html',
  styleUrl: './platform-icons.component.scss',
})
export class PlatformIconsComponent {
  @Input() platforms: Platform[] = [];

  readonly MAX_INLINE_PLATFORMS = 3;
  readonly globeIcon = GLOBE_ICON;

  @HostBinding('class.wrap-row')
  get wrapRow(): boolean {
    return (this.platforms?.length ?? 0) > this.MAX_INLINE_PLATFORMS;
  }

  get hasPlatforms(): boolean {
    return (this.platforms?.length ?? 0) > 0;
  }

  getIconSrc(platform: Platform): string | null {
    return PLATFORM_ICON_MAP[platform.toLowerCase()] ?? null;
  }
}
